import {useContext} from "react"
import {EcpProjectsContext} from "../contexts/EcpProjectsContext"

export function useEcpProjectsContext() {
    const context = useContext(EcpProjectsContext)
    if (!context) {
        throw new Error("useEcpProjectsContext must be used within a EcpProjectsContext")
    }
    return context
}